import React from "react";
import { Form, Input, Checkbox, Select, Spin, InputNumber } from "antd";
import { OneFrontDatePicker } from "../../Components/Forms/BookyDatePicker";
import { BookyPhoneInput } from "../../Components/Forms/BookyPhoneInput";
import { UiControlType } from "../../Types/UiControlType";
import { useCustomListLookupDataForForm } from "../../Hooks/useCustomListLookupDataForForm";
import { WebApiCustomListsDtoCustomListItemDto } from "../../Repository/eventbookyapi";
import { TextService } from "../../Services/TextService";

const { Option } = Select;


const CustomListItemForm = ({
    form,
    customFields,
    lookupOptions,
    mode
}: {
    form: any,
    customFields: any[],
    lookupOptions?: WebApiCustomListsDtoCustomListItemDto[],
    mode: "add" | "edit"
}) => {
    const GetText = TextService.GetText;

    return (
        <Form form={form} layout="vertical">
            {customFields.map(field => {
                if (field.uiControl === UiControlType.Date) {
                    return (
                        <OneFrontDatePicker
                            key={field.id}
                            name={field.id}
                            label={field.nameAdmin}
                            required={field.mandatoryAdmin}
                        />
                    );
                }
                if (field.uiControl === UiControlType.PhoneNumber) {
                    return (
                        <BookyPhoneInput
                            key={field.id}
                            name={field.id}
                            label={field.nameAdmin}
                            requiredMessage={field.mandatoryAdmin ? `Ange ${field.nameAdmin}` : undefined}
                        />
                    );
                }
                let input = <Input />;
                if (field.uiControl === UiControlType.Email) input = <Input type="email" />;
                if (field.uiControl === UiControlType.Number) input = <InputNumber style={{ width: '100%' }} controls={false} precision={0} />;
                if (field.uiControl === UiControlType.Currency) input = <InputNumber style={{ width: '100%' }} addonAfter={GetText("Common_CurrencySymbol")} precision={2} controls={false} />;
                if (field.uiControl === UiControlType.Decimal) input = <InputNumber style={{ width: '100%' }} controls={false} precision={2} />;
                if (field.uiControl === UiControlType.YesNo) input = <Checkbox checked={form.getFieldValue(field.id)} />;
                if (field.uiControl === UiControlType.Lookup) {
                    const options = lookupOptions;
                    input = !options ? <Spin size="small" /> : (
                        <Select
                            showSearch
                            value={form.getFieldValue(field.id)}
                            filterOption={(input, option) => {
                                const label = option?.children;
                                return label ? label.toString().toLowerCase().includes(input.toLowerCase()) : false;
                            }}
                        >
                            {options.map((opt: WebApiCustomListsDtoCustomListItemDto) => (
                                <Option key={String(opt.id)} value={opt.id}>{opt.fieldValues![0]?.fieldValue || opt.id?.toString()}</Option>
                            ))}
                        </Select>
                    );
                }
                if (field.uiControl === UiControlType.Dropdown) input = (
                    <Select>
                        {field.alternatives!.split(";").map((opt: any) => (
                            <Option key={opt} value={opt}>{opt}</Option>
                        ))}
                    </Select>
                );
                return (
                    <Form.Item
                        key={field.id}
                        name={field.id}
                        label={field.nameAdmin}
                        {...((field.uiControl === UiControlType.YesNo) ? { valuePropName: "checked" } : {})}
                        rules={[
                            ...(field.mandatoryAdmin ? [{ required: true, message: `Ange ${field.nameAdmin}` }] : []),
                            ...(field.uiControl === UiControlType.Email ? [{ type: 'email' as const, message: GetText("Common_InvalidEmail") }] : [])
                        ]}
                    >
                        {input}
                    </Form.Item>
                );
            })}
        </Form>
    );
};

export default CustomListItemForm;
